import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "io-customer-feedbacks__feedback-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_IoSpacer = _resolveComponent("IoSpacer")!
  const _component_slide = _resolveComponent("slide")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_Observer = _resolveComponent("Observer")!

  return (_openBlock(), _createBlock(_component_Observer, {
    class: _normalizeClass(["io-customer-feedbacks", {
            'observed': _ctx.observed,
        }]),
    threshold: 0.38197,
    onObserveenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.observed = true))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_carousel, null, {
        addons: _withCtx(({ slidesCount }) => [
          (slidesCount > 1)
            ? (_openBlock(), _createBlock(_component_Pagination, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createBlock(_component_slide, {
              key: item.id,
              class: "io-customer-feedbacks__feedback"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_FaIcon, { icon: "fas fa-quote-left" }),
                  _createElementVNode("div", {
                    innerHTML: item.content
                  }, null, 8, _hoisted_2),
                  _createVNode(_component_FaIcon, { icon: "fas fa-quote-right" })
                ]),
                _createVNode(_component_IoSpacer, { size: "m" }),
                _createElementVNode("div", {
                  class: "io-customer-feedbacks__feedback-name",
                  innerHTML: `- ${item.name}`
                }, null, 8, _hoisted_3),
                _createVNode(_component_IoSpacer, { size: "m" }),
                _createElementVNode("div", {
                  class: "io-customer-feedbacks__feedback-source",
                  innerHTML: item.source
                }, null, 8, _hoisted_4)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class", "threshold"]))
}